"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Theme = _interopRequireDefault(require("@airasia/phoenix-components/components/Theme"));

var _Banner = _interopRequireDefault(require("../Banner"));

var _constant = require("../constant");

var _utilities = _interopRequireDefault(require("../../utilities"));

var _HeroBannerPagination = _interopRequireDefault(require("./HeroBannerPagination"));

var _heroBanner = _interopRequireDefault(require("./heroBanner.proptypes"));

var _constant2 = require("./constant");

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj.default = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}
/* eslint-disable no-param-reassign */


var HeroBannerContainer = _styledComponents.default.div.withConfig({
  displayName: "HeroBanner__HeroBannerContainer",
  componentId: "vo44xe-0"
})(["position:relative;min-height:", ";width:", ";height:", ";overflow:hidden;"], _constant2.HERO_BANNER_MIN_HEIGHT, function (props) {
  return props.width;
}, function (props) {
  return props.height;
});

var ScrollBehavior = (0, _styledComponents.css)(["::-webkit-scrollbar{display:none;}-ms-overflow-style:none;scrollbar-width:none;-webkit-overflow-scrolling:touch;scroll-snap-type:x mandatory;-ms-scroll-snap-type:x mandatory;-webkit-scroll-snap-type:x mandatory;"]);

var BannersContainer = _styledComponents.default.div.withConfig({
  displayName: "HeroBanner__BannersContainer",
  componentId: "vo44xe-1"
})(["display:flex;overflow:hidden;scroll-behavior:smooth;height:inherit;> div{flex:0 0 auto;scroll-snap-align:start;transform:translate3d(0,0,0);-webkit-transform:translate3d(0,0,0);}", " position:relative;overflow:visible;overflow-x:visible;transition:all 0.5s ease-in-out;&.notransition{transition:none !important;}"], function (props) {
  return props.isMobile && (0, _styledComponents.css)(["overflow-x:auto;", ";"], ScrollBehavior);
});

var HeroBannerPaginationContainer = _styledComponents.default.div.withConfig({
  displayName: "HeroBanner__HeroBannerPaginationContainer",
  componentId: "vo44xe-2"
})(["position:absolute;left:0;right:0;bottom:", ";display:flex;justify-content:center;", ""], function (props) {
  return props.paginationContainerBottomSpace || '24px';
}, function (props) {
  return props.isMobile && !props.paginationContainerBottomSpace && (0, _styledComponents.css)(["bottom:8px;"]);
});

var HeroBanner = function HeroBanner(props) {
  var bannerDetails = props.bannerDetails,
      selectedBanner = props.selectedBanner,
      width = props.width,
      height = props.height,
      withTimer = props.withTimer,
      timer = props.timer,
      gtmParameters = props.gtmParameters,
      queryParams = props.queryParams,
      gtmConsumerName = props.gtmConsumerName,
      fireGtm = props.fireGtm,
      pageColor = props.pageColor,
      activePageColor = props.activePageColor,
      customProperties = props.customProperties,
      accessible = props.accessible,
      theme = props.theme,
      indexNumber = props.indexNumber,
      device = props.device,
      mobileViewHeight = props.mobileViewHeight,
      alignButtonContainer = props.alignButtonContainer,
      alignHeadlineContainer = props.alignHeadlineContainer,
      enableProgressiveImageLoading = props.enableProgressiveImageLoading,
      lazyLoadImage = props.lazyLoadImage,
      placeHolderBackground = props.placeHolderBackground,
      alignHeadlineVerticalContainer = props.alignHeadlineVerticalContainer,
      headlineVerticalContainerTopSpace = props.headlineVerticalContainerTopSpace,
      headlineVerticalContainerBottomSpace = props.headlineVerticalContainerBottomSpace,
      paginationContainerBottomSpace = props.paginationContainerBottomSpace,
      onBannerClick = props.onBannerClick;

  var _ref = bannerDetails || {},
      bannerID = _ref.bannerID;

  var _ref2 = gtmParameters || {},
      event = _ref2.event,
      eventActionClick = _ref2.eventActionClick,
      eventActionView = _ref2.eventActionView,
      eventLabelView = _ref2.eventLabelView,
      eventLabelCardClick = _ref2.eventLabelCardClick;

  var _ref3 = gtmParameters || {},
      eventCategory = _ref3.eventCategory;

  var _useState = (0, _react.useState)(selectedBanner),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeBanner = _useState2[0],
      setActiveBanner = _useState2[1];

  var _useState3 = (0, _react.useState)(true),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      showbanner = _useState4[0],
      setShowbanner = _useState4[1];

  var _useState5 = (0, _react.useState)(bannerDetails.length),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      herobannerLength = _useState6[0],
      setHerobannerLength = _useState6[1];

  var _useState7 = (0, _react.useState)(false),
      _useState8 = (0, _slicedToArray2.default)(_useState7, 2),
      paginationAccessible = _useState8[0],
      setPaginationAccessible = _useState8[1];

  var activeIndex = activeBanner;
  var bannerContainerRef = (0, _react.useRef)(null);
  var heroBannerInterval;

  var setActiveBannerAndIndex = function setActiveBannerAndIndex(index) {
    setActiveBanner(index);
    activeIndex = index;
  };

  var isDesktopView = function isDesktopView() {
    return device === _constant.DEVICE_TYPE.DESKTOP;
  };

  var isMobileView = function isMobileView() {
    return device === _constant.DEVICE_TYPE.MOBILE;
  };

  var getImageURL = function getImageURL(bannerDetail) {
    if (device === _constant.DEVICE_TYPE.TABLET) {
      return bannerDetail.tabletImage;
    }

    if (device === _constant.DEVICE_TYPE.MOBILE) {
      return bannerDetail.mobileImage;
    }

    return bannerDetail.desktopImage;
  };

  var validHeroBannerSize = function validHeroBannerSize() {
    var validLength = 0;
    bannerDetails.forEach(function (d) {
      if (getImageURL(d)) validLength += 1;
    });
    if (validLength === 0) setShowbanner(false);
    setHerobannerLength(validLength);
  };

  (0, _react.useEffect)(function () {
    validHeroBannerSize(); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerDetails]);

  var paginationSelectionHandler = function paginationSelectionHandler(index) {
    if (bannerContainerRef && bannerContainerRef.current) {
      // if (isDesktopView() && !isIEorSafari()) {
      var isLast = index === bannerDetails.length;

      if (isDesktopView()) {
        setActiveBannerAndIndex(isLast ? 0 : index);
      }

      var bannerContainerWidth = bannerContainerRef.current.offsetWidth;
      var scrollTo = index * bannerContainerWidth;
      bannerContainerRef.current.style.transform = "translateX(-".concat(scrollTo, "px)");
    }
  };

  clearInterval(heroBannerInterval); //   Starts the interval

  if (herobannerLength > 1) {
    heroBannerInterval = setInterval(function () {
      if (!withTimer) {
        clearInterval(heroBannerInterval);
        return;
      }

      var newIndex = activeIndex + 1;

      if (newIndex > herobannerLength) {
        newIndex = 0;
      }

      paginationSelectionHandler(newIndex);
    }, timer);
  }

  var getTransformValue = function getTransformValue(transform) {
    if (!transform) {
      return 0;
    }

    var transformSplit = transform.split('(');
    var value = transformSplit[1].split('px')[0];
    return Number(value);
  };

  (0, _react.useEffect)(function () {
    if (!bannerContainerRef) {
      return;
    }

    var tempIndex = activeIndex;
    var isTouchStart = false;
    var bannerContainerRefCurrent = bannerContainerRef.current;
    var bannerWidth = bannerContainerRefCurrent.offsetWidth;
    var isLast = false;
    var sx;
    var cx = 0;
    var transitionStartHandler;
    var transitionEndHandler;
    var touchstartHandler;
    var touchmoveHandler;

    if (herobannerLength <= 1) {
      if (bannerContainerRef && bannerContainerRef.current) {
        bannerContainerRef.current.style.removeProperty('transform');
      }

      bannerContainerRefCurrent.removeEventListener('transitionstart', transitionStartHandler, false);
      bannerContainerRefCurrent.removeEventListener('transitionend', transitionEndHandler, false);
      bannerContainerRefCurrent.removeEventListener('touchstart', touchstartHandler, false);
      bannerContainerRefCurrent.removeEventListener('touchmove', touchmoveHandler, false);
      setActiveBannerAndIndex(0);
      return;
    }

    transitionStartHandler = function transitionStartHandler() {
      var transformValue = getTransformValue(bannerContainerRefCurrent.style.transform);
      var newIndex = Math.ceil(transformValue / bannerWidth) * -1;

      if (tempIndex !== newIndex) {
        isLast = newIndex === bannerDetails.length;

        if (!isDesktopView()) {
          setActiveBannerAndIndex(isLast ? 0 : newIndex);
        }

        var movedBy = bannerWidth * newIndex * -1;
        bannerContainerRefCurrent.style.transform = "translateX(".concat(movedBy, "px)");
        tempIndex = newIndex;
        isTouchStart = false;
      }
    };

    transitionEndHandler = function transitionEndHandler() {
      var placeHolderBannerDisplayed = tempIndex === herobannerLength;

      if (placeHolderBannerDisplayed) {
        bannerContainerRefCurrent.classList.add('notransition');
        bannerContainerRefCurrent.style.transform = "translateX(0px)"; // eslint-disable-next-line no-unused-expressions

        bannerContainerRefCurrent.offsetHeight; // hack to force a css reflow

        bannerContainerRefCurrent.classList.remove('notransition');

        if (isLast) {
          tempIndex = 0;
        }
      }
    };

    bannerContainerRefCurrent.addEventListener('transitionstart', transitionStartHandler, false);
    bannerContainerRefCurrent.addEventListener('transitionend', transitionEndHandler, false);

    if (isDesktopView()) {
      return;
    }

    touchstartHandler = function touchstartHandler(e) {
      var touches = e.touches[0];
      cx = bannerWidth * tempIndex * -1;
      sx = touches.pageX - cx;
      isTouchStart = true;
    };

    touchmoveHandler = function touchmoveHandler(e) {
      if (!isTouchStart) {
        return;
      }

      var touches = e.touches[0];
      var totalWidth = bannerWidth * bannerDetails.length * -1;
      var pageX = touches.pageX - sx;
      var movedBy = pageX >= 0 ? 0 : pageX;
      movedBy = movedBy <= totalWidth ? totalWidth : movedBy;
      var newIndex = Math.ceil(movedBy * -1 / bannerWidth);
      bannerContainerRefCurrent.style.transform = "translateX(".concat(movedBy, "px)");

      if (tempIndex !== newIndex) {
        movedBy = bannerWidth * newIndex * -1;
        bannerContainerRefCurrent.style.transform = "translateX(".concat(movedBy, "px)");
        isTouchStart = false;
      }
    };

    bannerContainerRefCurrent.addEventListener('touchstart', touchstartHandler, false);
    bannerContainerRefCurrent.addEventListener('touchmove', touchmoveHandler, false); // eslint-disable-next-line consistent-return

    return function () {
      bannerContainerRefCurrent.removeEventListener('transitionstart', transitionStartHandler, false);
      bannerContainerRefCurrent.removeEventListener('transitionend', transitionEndHandler, false);
      bannerContainerRefCurrent.removeEventListener('touchstart', touchstartHandler, false);
      bannerContainerRefCurrent.removeEventListener('touchmove', touchmoveHandler, false);
    }; // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [bannerContainerRef, herobannerLength]);
  (0, _react.useEffect)(function () {
    if (selectedBanner > 0) {
      paginationSelectionHandler(selectedBanner);
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [selectedBanner]);
  (0, _react.useEffect)(function () {
    if (!withTimer) {
      clearInterval(heroBannerInterval);
    }

    return function () {
      return clearInterval(heroBannerInterval);
    }; //  Clear interval when unmount
  }, [heroBannerInterval, withTimer]);
  (0, _react.useEffect)(function () {
    setActiveBanner(selectedBanner);
  }, [selectedBanner]);

  var getHeight = function getHeight() {
    if (isMobileView()) {
      if (mobileViewHeight && !(0, _isEmpty.default)(mobileViewHeight)) {
        return mobileViewHeight;
      }

      return _constant2.HERO_BANNER_MOBILE_HEIGHT;
    }

    return height;
  };

  var createGtmObject = function createGtmObject() {
    var dataForGtm = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : eventLabelView;
    var click = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    eventCategory = eventCategory ? eventCategory.replace('{{consumername}}', gtmConsumerName || null) : null;
    dataForGtm = dataForGtm ? dataForGtm.replace('{{bannerorder}}', indexNumber || null).replace('{{bannerposition}}', activeIndex + 1 || null).replace('{{bannerid}}', bannerDetails[activeBanner].bannerID || null).replace('{{headline}}', bannerDetails[activeBanner].headline || null).replace('{{subheadline}}', bannerDetails[activeBanner].subheadline || null) : null;
    var obj = {
      event: event,
      'eventDetails.category': eventCategory,
      'eventDetails.action': "".concat(click ? eventActionClick : eventActionView),
      'eventDetails.label': dataForGtm
    }; // By default GTM will fire for Herobanner

    if (obj && fireGtm) fireGtm(obj, 'true');
  };

  var firstBanner = bannerDetails[0];
  var paginationAltTexts = bannerDetails.map(function (b) {
    return b.altText;
  });

  var bannerKeyDownHandler = function bannerKeyDownHandler() {
    setPaginationAccessible(true);

    if (typeof document !== 'undefined') {
      var page = document.getElementById("heroBanner-pagination-".concat(activeBanner));

      if (page) {
        page.focus();
      }
    }
  };

  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, showbanner && /*#__PURE__*/_react.default.createElement(HeroBannerContainer, (0, _extends2.default)({
    width: width,
    height: getHeight()
  }, customProperties), /*#__PURE__*/_react.default.createElement(BannersContainer, {
    ref: bannerContainerRef,
    isMobile: isMobileView()
  }, bannerDetails.map(function (d, index) {
    return /*#__PURE__*/_react.default.createElement(_Banner.default // eslint-disable-next-line react/no-array-index-key
    , (0, _extends2.default)({
      key: "hero_banner_".concat(index)
    }, d, {
      enableProgressiveImageLoading: enableProgressiveImageLoading,
      imageURL: getImageURL(d),
      tags: d.tags,
      showButton: d.showButton,
      idConfig: {
        parentName: 'heroBanner',
        widgetName: bannerID,
        index: "".concat(index)
      },
      lazyLoadImage: lazyLoadImage,
      width: width,
      height: getHeight(),
      queryParams: queryParams,
      theme: theme,
      device: device,
      gtmEventData: eventLabelCardClick,
      fireGtm: createGtmObject,
      placeHolderBackground: placeHolderBackground,
      alignButtonContainer: alignButtonContainer,
      alignHeadlineContainer: alignHeadlineContainer,
      alignHeadlineVerticalContainer: alignHeadlineVerticalContainer,
      headlineVerticalContainerTopSpace: headlineVerticalContainerTopSpace,
      headlineVerticalContainerBottomSpace: headlineVerticalContainerBottomSpace,
      onBannerClick: onBannerClick,
      accessibility: {
        banner: activeBanner === index && accessible,
        subheadline: false,
        headline: false
      },
      customProperties: {
        banner: {
          'aria-label': "Showing ".concat(index + 1, " banner of ").concat(herobannerLength, " banners. ").concat(d.altText, ". Actionable Left click or press enter to proceed or press down arrow to visit next section"),
          onKeyDown: function onKeyDown(e) {
            return _utilities.default.keyDownHandler(e, bannerKeyDownHandler, _constant.KEY_CODE.ARROW_DOWN);
          }
        },
        overlay: d.customProperties && d.customProperties.overlay
      }
    }));
  }), herobannerLength > 1 && /*#__PURE__*/_react.default.createElement(_Banner.default, (0, _extends2.default)({}, firstBanner, {
    imageURL: getImageURL(firstBanner),
    tags: firstBanner.tags,
    showButton: firstBanner.showButton,
    width: width,
    height: getHeight(),
    queryParams: queryParams,
    theme: theme,
    device: device,
    gtmEventData: eventLabelCardClick,
    fireGtm: createGtmObject,
    alignButtonContainer: alignButtonContainer,
    alignHeadlineContainer: alignHeadlineContainer,
    alignHeadlineVerticalContainer: alignHeadlineVerticalContainer,
    placeHolderBackground: placeHolderBackground,
    headlineVerticalContainerTopSpace: headlineVerticalContainerTopSpace,
    headlineVerticalContainerBottomSpace: headlineVerticalContainerBottomSpace,
    onBannerClick: onBannerClick,
    accessibility: {
      banner: false,
      subheadline: false,
      headline: false
    },
    customProperties: {
      banner: {
        'aria-label': firstBanner.altText
      },
      overlay: firstBanner.customProperties && firstBanner.customProperties.overlay
    }
  }))), /*#__PURE__*/_react.default.createElement(HeroBannerPaginationContainer, {
    isMobile: isMobileView(),
    paginationContainerBottomSpace: paginationContainerBottomSpace
  }, /*#__PURE__*/_react.default.createElement(_HeroBannerPagination.default, {
    pages: herobannerLength,
    activeIndex: activeBanner,
    onSelection: paginationSelectionHandler,
    pageColor: pageColor,
    activePageColor: activePageColor,
    accessible: paginationAccessible,
    theme: theme,
    fireGtm: createGtmObject,
    pageAltTexts: paginationAltTexts
  }))));
};

HeroBanner.propTypes = _heroBanner.default.PropTypes;
HeroBanner.defaultProps = _heroBanner.default.DefaultProps;
var _default = HeroBanner;
exports.default = _default;